import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n';
import InstallAppPage from './pages/InstallAppPage';
import LandingPage from './pages/LandingPage';
import MonitorPage from './pages/MonitorPage';

function App() {
  return (
    // Inside the router, because `?lang=` is part of the resolution chain and
    // has to be re-read when the location changes.
    <Router>
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/ping/:ping_id" element={<InstallAppPage />} />
          <Route path="/monitor/:monitor_link_id" element={<MonitorPage />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </LanguageProvider>
    </Router>
  );
}

export default App;
